import { render } from "./TheLoader.vue?vue&type=template&id=084e6dee&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=084e6dee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e6dee"]])

export default __exports__